
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import useBreakpoint from '../_config/hooks/useBreakpoint';
import { observeLayoutTargets, updateLayoutOffsets } from '../_config/layoutMetrics';
import AppHeader from './AppHeader.jsx';

const HeaderLayout = ({ children, match }) => {
  const { isPhone } = useBreakpoint();
  useEffect(() => {
    const scheduleUpdate = () => updateLayoutOffsets();

    scheduleUpdate();
    let disconnectObservers = observeLayoutTargets(scheduleUpdate);
    const retry = window.setTimeout(() => {
      disconnectObservers();
      disconnectObservers = observeLayoutTargets(scheduleUpdate);
      scheduleUpdate();
    }, 300);

    window.addEventListener('resize', scheduleUpdate);
    return () => {
      disconnectObservers();
      window.clearTimeout(retry);
      window.removeEventListener('resize', scheduleUpdate);
    };
  }, [match && match.url]);

  return (
    <div style={{ zoom: isPhone ? undefined : '80%', backgroundColor: 'white' }}>
      { /* TODO: workaround to make header update when location changes */ }
      <AppHeader match={match} />
      <div className="r-app-content" style={{ paddingLeft: isPhone ? 0 : 250 }}>
        {children}
      </div>
    </div>
  );
};

export default connect()(withRouter(HeaderLayout));
